var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseChart',{attrs:{"type":_vm.type,"data":_vm.data,"h":_vm.h,"max_height":_vm.max_height,"min_height":_vm.min_height,"scale":_vm.scale,"theme":_vm.theme,"theme_obj":_vm.theme_obj},on:{"renderCompalte":function (value) { return _vm.renderCompalte(value); }}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e10d540","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Chart.vue
// module id = null
// module chunks = 